import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { AppDispatch } from "../store";
import { paymentMethodActions } from "../slices/paymentMethod";
import { getErrorMessage } from "../../utils/errorUtils";
import { PaymentMethodRequestDto } from "../../shared/dtos/paymentMethod/PaymentMethodRequestDto";
import { PaymentMethodResponseDto } from "../../shared/dtos/paymentMethod/PaymentMethodResponseDto";
import { UpdatePaymentMethodPayload } from "../../shared/interfaces/paymentMethod/UpdatePaymentMethodPayload";
import { PaginationQueryDto } from "../../shared/dtos/common/PaginationQueryDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { PaginatedResponse } from "../../shared/dtos/common/PaginatedResponse";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const getPaymentMethods =
  (params?: PaginationQueryDto) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(paymentMethodActions.setLoadingFetchAll());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<PaginatedResponse<PaymentMethodResponseDto>>
      >("/payment-methods", {
        headers: { requiresAuth: true },
        params,
      });
      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(paymentMethodActions.setItems(data.data.content));
        dispatch(paymentMethodActions.setPagination(data.data.pagination));
      }
    } catch (error) {
      dispatch(paymentMethodActions.setErrorFetchAll(getErrorMessage(error)));
    }
  };

export const createPaymentMethod =
  (values: PaymentMethodRequestDto) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(paymentMethodActions.setLoadingCreate());
    try {
      const { data } = await axiosInstance.post<
        ApiResponseDto<PaymentMethodResponseDto>
      >("/payment-methods", values, {
        headers: { requiresAuth: true },
      });
      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        toast.success(data.message || "Method created!");
        dispatch(paymentMethodActions.createSuccess(data.data));
        dispatch(
          paymentMethodActions.setServerStatus({
            operation: "create",
            status: data.statusCode || 201,
          }),
        );
      }
    } catch (error) {
      dispatch(paymentMethodActions.setErrorCreate(getErrorMessage(error)));
    }
  };

export const updatePaymentMethod =
  (payload: UpdatePaymentMethodPayload) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(paymentMethodActions.setLoadingUpdate());
    try {
      const { data } = await axiosInstance.put<
        ApiResponseDto<PaymentMethodResponseDto>
      >(`/payment-methods/${payload.id}`, payload.values, {
        headers: { requiresAuth: true },
      });
      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        toast.success(data.message || "Method updated!");
        dispatch(paymentMethodActions.updateSuccess(data.data));
      }
    } catch (error) {
      dispatch(paymentMethodActions.setErrorUpdate(getErrorMessage(error)));
    }
  };

export const deletePaymentMethod =
  (id: string) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(paymentMethodActions.setLoadingDelete());
    try {
      const { data } = await axiosInstance.delete<ApiResponseDto<void>>(
        `/payment-methods/${id}`,
        {
          headers: { requiresAuth: true },
        },
      );
      if (data.status === ApiResponseStatus.SUCCESS) {
        toast.success(data.message || "Method deleted!");
        dispatch(paymentMethodActions.deleteSuccess(id));
      }
    } catch (error) {
      dispatch(paymentMethodActions.setErrorDelete(getErrorMessage(error)));
    }
  };

export const resetPaymentMethodServerStatus =
  () =>
  (dispatch: AppDispatch): void => {
    dispatch(paymentMethodActions.setServerStatus(null));
  };
